import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useEquiposAnterior() {
    const equiposAnterior = ref([]);
    const loading = ref(false);
    const submitting = ref(false);

    /**
     * Fetch equipos from previous season.
     * @param {number|string} listaId
     * @returns {Promise<Array>} equipos data array
     */
    async function fetchEquiposAnterior(listaId) {
        loading.value = true;
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.equipos.anterior'),
                { lista_id: listaId }
            );
            equiposAnterior.value = res.data?.data || res.data || [];
            return equiposAnterior.value;
        } catch (error) {
            console.error('Error fetching equipos anterior:', error);
            equiposAnterior.value = [];
            throw error;
        } finally {
            loading.value = false;
        }
    }

    /**
     * Copy selected equipos to current season.
     * @param {number|string} listaId
     * @param {Array<number>} equipoIds - IDs of equipos to copy
     * @returns {Promise<{copiados: number, message: string}>}
     */
    async function cargarEquipos(listaId, equipoIds) {
        submitting.value = true;
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.equipos.cargar'),
                { lista_id: listaId, equipo_ids: equipoIds }
            );
            return res.data;
        } catch (error) {
            console.error('Error cargando equipos:', error);
            throw error;
        } finally {
            submitting.value = false;
        }
    }

    return {
        equiposAnterior,
        loading,
        submitting,
        fetchEquiposAnterior,
        cargarEquipos
    };
}
